'use client';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { TabItem } from './children/TabItem';
import styles from './HorizontalTabs.module.scss';
export const Alignment = {
    LEFT: 'left',
    CENTER: 'center',
};
export const HorizontalTabs = ({ children, className = '', tabs = [], defaultTabId = 0, showUnderline = true, alignment = Alignment.LEFT, onClick, }) => {
    const [activeTab, setActiveTab] = useState(defaultTabId);
    const onClickTabItem = (tab) => {
        const { id, label } = tab;
        setActiveTab(Number(id));
        onClick && onClick(Number(id), label, tab);
    };
    useEffect(() => {
        setActiveTab(defaultTabId);
    }, [defaultTabId]);
    return (<>
      <div className={cx(styles.tabContainer, {
            [styles.tabContainer__underlined]: showUnderline,
        }, className)}>
        {tabs.length > 1 ? (<ul className={cx(styles.tabs, {
                [styles.tabs__left]: alignment === 'left',
                [styles.tabs__center]: alignment === 'center',
            })}>
            {tabs === null || tabs === void 0 ? void 0 : tabs.map((tab) => (<TabItem tab={tab} activeTabId={activeTab} onClickTab={onClickTabItem} key={tab.id}/>))}
          </ul>) : null}
      </div>
      {(children === null || children === void 0 ? void 0 : children.length) ? children[activeTab] : null}
    </>);
};
